function initQuantitySelector() {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".js-qty-btn");
    if (!btn) return; // not our button

    const container = btn.closest(".c-quantity-selector");
    if (!container) return;

    const input = container.querySelector('input[name="quantity"]');
    if (!input) return;

    const change = parseInt(btn.dataset.change, 10);
    const newQty = Math.max(1, parseInt(input.value || "1", 10) + change);
    input.value = newQty;

    // optional: trigger event so other scripts or listeners react
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

initQuantitySelector();

export { initQuantitySelector };
